import $ from 'jquery'
import axios from 'axios'

let rotateInterval

function initBannerCountdown() {
  if ($('.aprenda-banner .countdown').length) {
    const countdownEnd = new Date($('.aprenda-banner .countdown').data().end)
    $('.aprenda-banner .countdown')
      .countdown(countdownEnd)
      .on('update.countdown', function (event) {
        let format = '%Hh%Mm%Ss'
        if (event.offset.totalDays > 0) {
          format = '%D dia%!D ' + format
        }
        $(this).html(event.strftime(format))
      })
  }
}

function startBannerRotation(banner) {
  if (banner.arr.length === 1) {
    return
  }
  setTimeout(function () {
    $('.aprenda-banner .inner').hide().html(banner.arr[0]).show('fast')
    initBannerCountdown()
    if (banner.strongColor) {
      $('.aprenda-banner .inner strong').css('color', banner.strongColor)
    }
    clearInterval(rotateInterval)
  }, banner.endTimeout)
  let i = 1
  rotateInterval = setInterval(function () {
    if (!banner.arr[i]) {
      i = 0
    }
    $('.aprenda-banner .inner').hide().html(banner.arr[i]).show('fast')
    initBannerCountdown()
    if (banner.strongColor) {
      $('.aprenda-banner .inner strong').css('color', banner.strongColor)
    }
    i++
  }, banner.rotateTimeout)
}

export function setUpAprendaBanner() {
  axios.get('/banner').then(({ data: banner }) => {
    if (
      !banner ||
      !banner.enabled ||
      window.location.pathname.indexOf(banner.url) !== -1
    ) {
      return
    }
    clearInterval(rotateInterval)
    $('.aprenda-banner').remove()
    $('.aprenda-banner-spacer').remove()
    const navbar = $('.navbar').length ? $('.navbar') : $('.navbar-block')
    const parent = $('.internal-header').length ? $('.internal-header') : navbar

    parent.after(
      `<div class='aprenda-banner' style='background-color:${banner.bgColor}; height:${banner.height};'><a target='_blank' href='${banner.url}'><div class='inner' style='color:${banner.color};'>${banner.arr[0]}</div></a></div>`
    )

    initBannerCountdown()
    if (banner.strongColor) {
      $('.aprenda-banner .inner strong').css('color', banner.strongColor)
    }
    $('.aprenda-banner').after(
      '<div class="aprenda-banner-spacer" style="padding-top: ' +
        banner.height +
        '"></div>'
    )
    $('.course-sidebar, .lecture-content').addClass('banner-on')
    startBannerRotation(banner)
  })
}
